import React, {useEffect, useState} from 'react';
import DocumentsTreeView from "../../components/DocumentsTreeView/DocumentsTreeView.jsx";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined.js";
import {useDispatch, useSelector} from "react-redux";
import {
    getDocumentNodes,
    getLibraryNodes,
    selectCurrentHandbook,
    selectDocumentsTree,
    selectLibraryTree, selectNormativeArticles,
    selectNormativeDocuments,
    selectReferenceDescriptions,
    setDocumentsTree,
    setLibraryTree
} from "../../redux/reducers/library-reducer.js";
import ViewStreamIcon from "@material-ui/icons/ViewStream.js";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord.js";
import GetAppIcon from '@material-ui/icons/GetApp';
import {Box, Grid, IconButton, Tooltip} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack.js";
import Typography from "@material-ui/core/Typography";
import {downloadNormativeDocument} from "../../redux/reducers/normative-documents-reducer.js";
import LibrarySearchContainer from "../LibrarySearchContainer/LibrarySearchContainer.jsx";
import {createDescription} from "../../utils/descriptionTemplate.js";

const LibraryContainer = (props) => {
    const {projectID, loading, searchDialogOpen, onSearchDialogClose, onCommitNormativeArticle, shadow} = props

    const dispatch = useDispatch()

    const libraryNodes = useSelector(selectLibraryTree)
    const documentNodes = useSelector(selectDocumentsTree)
    const referenceDescriptions = useSelector(selectReferenceDescriptions)
    const normativeDocuments = useSelector(selectNormativeDocuments)
    const currentHandbook = useSelector(selectCurrentHandbook)
    const normativeArticles = useSelector(selectNormativeArticles)
    const selectLibrary = useSelector(selectLibraryTree)

    const [currentDocumentID, setCurrentDocumentID] = useState(null)

    const typeIcons = {
        normativeDocument: DescriptionOutlinedIcon,
        normativeChapter: ViewStreamIcon,
        normativeArticle: FiberManualRecordIcon
    }

    const iconTooltips = {
        normativeDocument: 'Документ',
        normativeChapter: 'Глава',
        normativeArticle: 'Пункт'
    }

    const handleCloseDocument = async () => {
        await setCurrentDocumentID(null)
        dispatch(setDocumentsTree(null))
    }

    useEffect(async () => {
        if (projectID) {
            await handleCloseDocument()
            if (JSON.stringify(selectLibrary) === '[]') {
               dispatch(getLibraryNodes(projectID)) 
            }     
        }
    }, [dispatch, projectID])

    const toolbarCallbacks = {
        onDoubleClick: (nodeID) => async () => {
            const [type, id] = nodeID.split('.')
            if (type === 'normativeDocument') {
                await setCurrentDocumentID(parseInt(id))
                await dispatch(getDocumentNodes(id))
            }
            if (type === 'normativeArticle' && onCommitNormativeArticle) {
                const selectedNormativeArticle = normativeArticles.find(article => article.id === parseInt(id))
                const selectedDocument = referenceDescriptions.find(ref => ref.normative_document === currentDocumentID)

                onCommitNormativeArticle({
                    ...selectedNormativeArticle,
                    reference: createDescription(selectedNormativeArticle.number, selectedDocument.description)
                })
            }
        }
    }

    return (
        <>
            <LibrarySearchContainer
                open={searchDialogOpen}
                onClose={onSearchDialogClose}
                normativeDocuments={currentDocumentID ? normativeDocuments.filter(doc => doc.id === currentDocumentID) : normativeDocuments}
                referenceDescriptions={referenceDescriptions}
                selectedHandbook={currentHandbook}
                onCommitNormativeArticle={onCommitNormativeArticle}
                shadow={shadow}
            />

            <Grid container direction={'column'} spacing={1}>
                <Grid item>
                    <Box hidden={!Boolean(currentDocumentID)}>
                        <Grid item container spacing={1} direction={'row'} alignItems={'center'}>
                            <Grid item>
                                <IconButton size={'small'} onClick={handleCloseDocument}><ArrowBackIcon/></IconButton>
                            </Grid>
                            <Grid item xs>
                                <Typography
                                    variant={'h6'}>{libraryNodes.find(doc => doc.id === currentDocumentID)?.name}</Typography>
                            </Grid>
                            <Grid item alignItems={'flex-end'}>
                                <Box hidden={!Boolean(libraryNodes.find(doc => doc.id === currentDocumentID)?.file)}>
                                    <Tooltip title={'Скачать документ'}>
                                        <IconButton
                                            size={'small'}
                                            onClick={async () => {
                                                await dispatch(downloadNormativeDocument(currentDocumentID))
                                            }}
                                        >
                                            <GetAppIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item>
                    <DocumentsTreeView
                        nodes={loading ? [] : documentNodes || libraryNodes}
                        typeIcons={typeIcons}
                        iconTooltips={iconTooltips}
                        toolbarCallbacks={toolbarCallbacks}
                        hideToolbar
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default LibraryContainer;